import { gql } from '@apollo/client';

export const fetchPaymentMethodUpdateLink = gql`
  query fetchPaymentMethodUpdateLink($id: ID!) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
    }
  }
`;
